import { render } from "./datadashboard.vue?vue&type=template&id=02847943&scoped=true"
import script from "./datadashboard.js?vue&type=script&lang=js"
export * from "./datadashboard.js?vue&type=script&lang=js"

import "./datadashboard.vue?vue&type=style&index=0&id=02847943&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02847943"]])

export default __exports__